import script from "./CartItemAdd.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItemAdd.vue?vue&type=script&setup=true&lang=ts"

import "./CartItemAdd.vue?vue&type=style&index=0&id=525a020d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525a020d"]])

export default __exports__